/**
 * Mutation to remove a category from a seller
 */
const removeCategoryFromSellerMutation = `
mutation RemoveCategoryFromSeller($sellerId: ID!, $categoryId: ID!) {
  updateMarketplace_seller(
    input: {
      id: $sellerId
      fields: {
        categories: {
          remove: [$categoryId]
        }
      }
    }
  ) {
    marketplace_seller {
      objectId
      categories {
        edges {
          node {
            objectId
            name
          }
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default removeCategoryFromSellerMutation;